{
  "block-market-north": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ],
      [
        5,
        0
      ],
      [
        5,
        1
      ],
      [
        5,
        2
      ],
      [
        6,
        0
      ],
      [
        6,
        1
      ],
      [
        6,
        2
      ],
      [
        7,
        0
      ],
      [
        7,
        1
      ],
      [
        7,
        2
      ],
      [
        8,
        0
      ],
      [
        8,
        1
      ],
      [
        9,
        0
      ],
      [
        9,
        1
      ],
      [
        10,
        0
      ],
      [
        10,
        1
      ],
      [
        10,
        2
      ],
      [
        11,
        0
      ],
      [
        11,
        1
      ],
      [
        11,
        2
      ],
      [
        12,
        0
      ],
      [
        12,
        1
      ],
      [
        12,
        2
      ],
      [
        13,
        0
      ],
      [
        13,
        1
      ],
      [
        14,
        0
      ],
      [
        14,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      },
      {
        "x": 9,
        "y": 0
      },
      {
        "x": 13,
        "y": 0
      },
      {
        "x": 19,
        "y": 0
      },
      {
        "x": 23,
        "y": 0
      },
      {
        "x": 29,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 7,
    "footW": 31,
    "roof_tint": "#8a5a3c",
    "storeys": 3
  },
  "block-riverside": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ],
      [
        5,
        0
      ],
      [
        5,
        1
      ],
      [
        5,
        2
      ],
      [
        6,
        0
      ],
      [
        6,
        1
      ],
      [
        6,
        2
      ],
      [
        7,
        0
      ],
      [
        7,
        1
      ],
      [
        8,
        0
      ],
      [
        8,
        1
      ],
      [
        9,
        0
      ],
      [
        9,
        1
      ],
      [
        10,
        0
      ],
      [
        10,
        1
      ],
      [
        11,
        0
      ],
      [
        11,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      },
      {
        "x": 7,
        "y": 0
      },
      {
        "x": 13,
        "y": 0
      },
      {
        "x": 17,
        "y": 0
      },
      {
        "x": 23,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 7,
    "footW": 25,
    "roof_hue": 190,
    "storeys": 3
  },
  "block-weavers-row": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ],
      [
        5,
        0
      ],
      [
        5,
        1
      ],
      [
        5,
        2
      ],
      [
        6,
        0
      ],
      [
        6,
        1
      ],
      [
        6,
        2
      ],
      [
        7,
        0
      ],
      [
        7,
        1
      ],
      [
        7,
        2
      ],
      [
        8,
        0
      ],
      [
        8,
        1
      ],
      [
        9,
        0
      ],
      [
        9,
        1
      ],
      [
        10,
        0
      ],
      [
        10,
        1
      ],
      [
        10,
        2
      ],
      [
        11,
        0
      ],
      [
        11,
        1
      ],
      [
        11,
        2
      ],
      [
        12,
        0
      ],
      [
        12,
        1
      ],
      [
        12,
        2
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      },
      {
        "x": 9,
        "y": 0
      },
      {
        "x": 13,
        "y": 0
      },
      {
        "x": 19,
        "y": 0
      },
      {
        "x": 23,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 7,
    "footW": 27,
    "roof_hue": 190,
    "storeys": 3
  },
  "church": {
    "cells": [
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        0,
        4
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        4
      ],
      [
        2,
        5
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 13,
    "footW": 7,
    "storeys": 3
  },
  "cottage": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 1
  },
  "cottage-plank": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 1,
    "wall_tint": "#e8dcc8"
  },
  "guildhall-square": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ],
      [
        2,
        4
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        3,
        2
      ],
      [
        3,
        3
      ],
      [
        3,
        4
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ],
      [
        4,
        2
      ],
      [
        4,
        3
      ],
      [
        4,
        4
      ]
    ],
    "doorCell": {
      "x": 5,
      "y": 0
    },
    "doorCells": [
      {
        "x": 5,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 11,
    "footW": 11,
    "roof_tint": "#667b78",
    "storeys": 2,
    "wall_tint": "#cbb997"
  },
  "house-brick": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 1
  },
  "house-dormer": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 1
  },
  "house-garden-wall": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 9,
    "footW": 7,
    "storeys": 1
  },
  "house-l": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 9,
    "footW": 7,
    "storeys": 1
  },
  "house-wood": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 1
  },
  "inn": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        3,
        2
      ],
      [
        3,
        3
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ],
      [
        4,
        2
      ],
      [
        4,
        3
      ]
    ],
    "doorCell": {
      "x": 5,
      "y": 0
    },
    "doorCells": [
      {
        "x": 5,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 9,
    "footW": 11,
    "storeys": 2
  },
  "manor-accent": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ]
    ],
    "doorCell": {
      "x": 5,
      "y": 0
    },
    "doorCells": [
      {
        "x": 5,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 11,
    "roof_tint": "#8a5a3c",
    "storeys": 2
  },
  "rowhouse-brick": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 5,
    "storeys": 2
  },
  "rowhouse-plaster": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 5,
    "storeys": 2
  },
  "rowhouse-timber": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 5,
    "storeys": 2
  },
  "rowhouse-wood": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 5,
    "storeys": 1
  },
  "shop-heavy": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ]
    ],
    "doorCell": {
      "x": 5,
      "y": 0
    },
    "doorCells": [
      {
        "x": 5,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 9,
    "roof_hue": 95,
    "storeys": 2
  },
  "townhouse-arched": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "roof_hue": 190,
    "storeys": 2,
    "wall_tint": "#c9c9b4"
  },
  "townhouse-brick": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "roof_tint": "#8a5a3c",
    "storeys": 2
  },
  "townhouse-brick-balcony": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 2
  },
  "townhouse-brick-row": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 2
  },
  "townhouse-bridge": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        5,
        0
      ],
      [
        5,
        1
      ],
      [
        6,
        0
      ],
      [
        6,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 15,
    "storeys": 2
  },
  "townhouse-double": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ],
      [
        5,
        0
      ],
      [
        5,
        1
      ]
    ],
    "doorCell": {
      "x": 7,
      "y": 0
    },
    "doorCells": [
      {
        "x": 7,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 13,
    "roof_tint": "#b9825a",
    "storeys": 2
  },
  "townhouse-grand": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ],
      [
        4,
        0
      ],
      [
        4,
        1
      ],
      [
        5,
        0
      ],
      [
        5,
        1
      ]
    ],
    "doorCell": {
      "x": 7,
      "y": 0
    },
    "doorCells": [
      {
        "x": 7,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 13,
    "storeys": 2,
    "wall_tint": "#e8dcc8"
  },
  "townhouse-l": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        2,
        2
      ],
      [
        2,
        3
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 9,
    "footW": 7,
    "storeys": 2
  },
  "townhouse-plaster-balcony": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 2
  },
  "townhouse-plaster-row": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 2
  },
  "townhouse-stairs": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 7,
    "footW": 5,
    "storeys": 2
  },
  "townhouse-stairs-stone": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 9,
    "footW": 5,
    "storeys": 2
  },
  "townhouse-tall": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 3
  },
  "townhouse-timber": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "roof_hue": 190,
    "storeys": 2
  },
  "townhouse-timber-row": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 7,
    "storeys": 2
  },
  "tudor-hero": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        0,
        4
      ],
      [
        0,
        5
      ],
      [
        0,
        6
      ],
      [
        0,
        7
      ],
      [
        0,
        8
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        1,
        2
      ],
      [
        1,
        3
      ],
      [
        1,
        4
      ],
      [
        1,
        5
      ],
      [
        1,
        6
      ],
      [
        1,
        7
      ],
      [
        1,
        8
      ],
      [
        2,
        6
      ],
      [
        2,
        7
      ],
      [
        2,
        8
      ],
      [
        3,
        6
      ],
      [
        3,
        7
      ],
      [
        3,
        8
      ],
      [
        4,
        6
      ],
      [
        4,
        7
      ],
      [
        4,
        8
      ],
      [
        5,
        0
      ],
      [
        5,
        1
      ],
      [
        5,
        2
      ],
      [
        5,
        3
      ],
      [
        5,
        4
      ],
      [
        5,
        5
      ],
      [
        5,
        6
      ],
      [
        5,
        7
      ],
      [
        5,
        8
      ],
      [
        6,
        0
      ],
      [
        6,
        1
      ],
      [
        6,
        2
      ],
      [
        6,
        3
      ],
      [
        6,
        4
      ],
      [
        6,
        5
      ],
      [
        6,
        6
      ],
      [
        6,
        7
      ],
      [
        6,
        8
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 19,
    "footW": 15,
    "roof_tint": "#53616a",
    "storeys": 3,
    "wall_tint": "#d8c6a8"
  },
  "village-barn": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ],
      [
        2,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        0
      ],
      [
        3,
        1
      ]
    ],
    "doorCell": {
      "x": 5,
      "y": 0
    },
    "doorCells": [
      {
        "x": 5,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 9,
    "storeys": 1
  },
  "village-house": {
    "cells": [
      [
        0,
        0
      ],
      [
        0,
        1
      ],
      [
        1,
        0
      ],
      [
        1,
        1
      ]
    ],
    "doorCell": {
      "x": 3,
      "y": 0
    },
    "doorCells": [
      {
        "x": 3,
        "y": 0
      }
    ],
    "enterable": true,
    "footH": 5,
    "footW": 5,
    "storeys": 1
  }
}
